<template>
    <div class="container-fluid m-2">
        <div class="snackbars">
            <div class="container">
                <div class="row justify-content-center">
                    <snackbar type="success" v-if="showNotification" v-on:close="closeNotification">
                        La décision a été envoyée par email à l'entreprise.
                    </snackbar>
                    <snackbar type="success" v-if="showNotificationWaiting" v-on:close="closeNotification">
                        La facture été envoyée par email à l'entreprise.
                    </snackbar>
                </div>
            </div>
        </div>
        <div class="row">
            <aside class="col-4 mt-4">
                <div class="section p-0 validations">
                    <div class="tabs">
                        <div class="tab pointer" :class="{ 'is-active' : !coveredMode }" @click="toggleMode">
                            <span>Demandes d'inscription </span><span
                            class="badge badge--orange">{{ allCompanies ? allCompanies.length : 0 }}</span>
                        </div>
                        <div class="tab pointer" :class="{ 'is-active' : coveredMode }" @click="toggleMode">
                            <span>Entreprises a valider </span><span
                            class="badge badge--orange">{{ coveredCompanies ? coveredCompanies.length : 0 }}</span>
                        </div>
                    </div>

                    <div v-if="coveredMode">
                        <h3 class="p-3">Entreprises a valider</h3>
                        <div
                            class="listitem pointer validations"
                            v-for="company in coveredCompanies"
                            :key="company.id"
                            v-if="coveredCompanies.length > 0"
                            @click="setSelectedCompany(company, true)">
                            <div class="listitem__name">
                                {{ company.name }}
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <h3 class="p-3">Demandes d'inscription</h3>
                        <div
                            class="listitem pointer validations"
                            v-for="company in allCompanies"
                            :key="company.id"
                            v-if="allCompanies.length > 0"
                            @click="setSelectedCompany(company, false)">
                            <div class="listitem__name">
                                {{ company.name }}
                            </div>
                        </div>
                    </div>
                </div>
            </aside>
            <div class="col-8">
                <div v-if="selectedCompany">
                    <div class="actionsBar actionBar--normalMargin  mt-3 mb-3">
                        <div class="ml-auto">
                            <button @click="previous" type="button" class="btn-dark-grey" :disabled='!hasPrevious'>
                                Précédent
                            </button>
                            <button type="button" class="btn-dark-grey" @click="postWaiting" v-if="!coveredMode">
                                Envoyer facture
                            </button>
                            <button type="button" class="btn-dark-grey" @click="postValidate" v-if="coveredMode">
                                Valider
                            </button>

                            <button @click="next" type="button" class="btn-dark-grey" :disabled='!hasNext'>
                                Suivant
                            </button>
                        </div>
                    </div>
                    <div class="section mt-4">
                        <div class="row" v-if="!coveredMode">
                            <div class="col-12">
                                <div class="section__infos mb-3">
                                    <svg viewBox="0 0 24 24">
                                        <use xlink:href="#information"></use>
                                    </svg>
                                    La facture est envoyée automatiquement par email à l'entreprise. L'entreprise est ensuite en attente de validation.
                                </div>
                            </div>
                        </div>
                        <div class="row">

                            <div class="col-2">
                                <div class="profileOverview__pic avatar avatar--large mb-4">
                                    <img v-if="selectedCompany.picture_url"
                                         :src="selectedCompany.picture_url"
                                         alt="" class="avatar__default">
                                </div>
                                <a :href="selectedCompany.view_url" class="btn-medium-grey" target="_blank">
                                    Voir profil
                                </a>
                            </div>
                            <div class="col-10">
                                <div class="profileOverview__infos">
                                    <h2 class="profileOverview__name">{{ selectedCompany.name }}</h2>

                                    <h3 class="mb-0">Demande d'inscription le</h3>
                                    <span class="profileOverview__name">{{ selectedCompany.sub_date }}</span>

                                    <h3 class="mb-0">Dernière mise à jour du profil</h3>
                                    <span class="profileOverview__name">{{ selectedCompany.profil_update }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-10 offset-2">
                                <h3>Participation aux éditions précédentes</h3>
                                <ul v-if="selectedCompany.subscriptions.length > 0" style="margin: 0">
                                    <li v-for="sub in selectedCompany.subscriptions">{{ sub.edition.name }}</li>
                                </ul>
                                <p v-else>Première édition</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="actionsBar actionBar--normalMargin  mt-3 mb-3">
                        <div class="ml-auto">
                            <button type="button" class="btn-dark-grey" disabled>
                                Précédent
                            </button>
                            <button type="button" class="btn-dark-grey" disabled>
                                Suivant
                            </button>
                        </div>
                    </div>
                    <div class="section mt-4">
                        <p>Aucune demande d'inscription a valider</p>
                    </div>
                </div>

            </div>
        </div>

    </div>
</template>

<script>

import moment from "moment";
import Snackbar from "../AppNotifications/Snackbar";

export default {
    components: {
        Snackbar
    },
    props: {
        companies: Array,
        waitingValidationCompanies: Array,
        routeWaiting: String,
        routeValidate: String,
        labels: Array,
        waitingStatus: String,
        icEcoTax: String,
        labelEcoTax: String
    },
    data: function () {
        return {
            selectedCompany: null,
            allCompanies: this.companies,
            coveredCompanies: this.waitingValidationCompanies,
            index: 0,
            indexCovered: 0,
            coveredMode: false,
            showNotification: false,
            showNotificationWaiting: false
        }
    },
    methods: {
        closeNotification(event) {
            this.showNotification = !event
        },
        format(birthDay) {
            return moment(birthDay).format('L')
        },
        toggleMode() {
            this.coveredMode = !this.coveredMode
            if (this.coveredMode) {
                this.selectedCompany = this.coveredCompanies[this.indexCovered]
            } else {
                this.selectedCompany = this.allCompanies[this.index]
            }
        },
        postWaiting() {
            if (this.routeWaiting) {
                axios.post(this.routeWaiting, {
                        'item': this.selectedCompany.pivot.id
                    }
                ).then((response) => {
                    this.coveredCompanies.push(this.selectedCompany)
                    this.allCompanies.splice(this.index, 1)
                    if (this.allCompanies.length > 0) {
                        if (this.index === this.allCompanies.length) {
                            this.index--
                        }
                        this.selectedCompany = this.allCompanies[this.index]
                    } else {
                        this.selectedCompany = null
                        this.index = 0
                    }
                    this.showNotificationWaiting = true
                }).catch(function (error) {
                    // error management?
                    console.log(error);
                });
            }
        },
        postValidate() {
            if (this.routeValidate) {
                axios.post(this.routeValidate, {
                        'item': this.selectedCompany.pivot.id
                    }
                ).then((response) => {
                    if (this.coveredMode) {
                        this.coveredCompanies.splice(this.index, 1)
                        if (this.coveredCompanies.length > 0) {
                            if (this.index === this.coveredCompanies.length) {
                                this.index--
                            }
                            this.selectedCompany = this.coveredCompanies[this.index]
                        } else {
                            this.selectedCompany = null
                            this.index = 0
                        }
                    } else {
                        this.allCompanies.splice(this.index, 1)
                        if (this.allCompanies.length > 0) {
                            if (this.index === this.allCompanies.length) {
                                this.index--
                            }
                            this.selectedCompany = this.allCompanies[this.index]
                        } else {
                            this.selectedCompany = null
                            this.index = 0
                        }
                    }
                }).catch(function (error) {
                    // error management?
                    console.log(error);
                });
            }

        },
        previous() {
            if (this.coveredMode) {
                if (this.coveredCompanies.length > 0) {
                    if (this.indexCovered > 0) {
                        this.indexCovered--
                        this.selectedCompany = this.coveredCompanies[this.indexCovered]
                    }
                } else {
                    this.indexCovered = 0;
                    this.selectedCompany = null
                }
            } else {
                if (this.allCompanies.length > 0) {
                    if (this.index > 0) {
                        this.index--
                        this.selectedCompany = this.allCompanies[this.index]
                    }
                } else {
                    this.indexCovered = 0;
                    this.selectedCompany = null
                }
            }
        },

        next() {
            if (this.coveredMode) {
                if (this.coveredCompanies.length > 0) {
                    if (this.indexCovered < this.coveredCompanies.length - 1) {
                        this.indexCovered++
                        this.selectedCompany = this.coveredCompanies[this.indexCovered]
                    }
                } else {
                    this.indexCovered = 0;
                    this.selectedCompany = null
                }
            } else {
                if (this.allCompanies.length > 0) {
                    if (this.index < this.allCompanies.length - 1) {
                        this.index++
                        this.selectedCompany = this.allCompanies[this.index]
                    }
                } else {
                    this.index = 0;
                    this.selectedCompany = null
                }
            }

        },
        setSelectedCompany(toDisplayCompany, mode) {
            this.coveredMode = mode
            if (this.coveredMode) {
                let newIndex = this.coveredCompanies.findIndex(company => company.id === toDisplayCompany.id)
                if (newIndex > -1) {
                    this.indexCovered = newIndex
                    this.selectedCompany = this.coveredCompanies[newIndex]
                }
            } else {
                let newIndex = this.allCompanies.findIndex(company => company.id === toDisplayCompany.id)
                if (newIndex > -1) {
                    this.index = newIndex
                    this.selectedCompany = this.allCompanies[newIndex]
                }
            }
        }
    },
    beforeMount() {
        if (this.allCompanies.length > 0) {
            this.selectedCompany = this.allCompanies[this.index]
        }
    },
    mounted() {

    },
    computed: {
        hasPrevious() {
            if (this.coveredMode) {
                if (this.coveredCompanies.length > 0 && this.indexCovered > 0) {
                    return true
                }
            } else {
                if (this.allCompanies.length > 0 && this.index > 0) {
                    return true
                }
            }
            return false
        },
        hasNext() {
            if (this.coveredMode) {
                if (this.coveredCompanies.length > 0 && this.indexCovered < this.coveredCompanies.length - 1) {
                    return true
                }
            } else {
                if (this.allCompanies.length > 0 && this.index < this.allCompanies.length - 1) {
                    return true
                }
            }
            return false
        }
    }
};
</script>
